<template>
  <ul :class="classes">
    <slot></slot>
  </ul>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
};
</script>
